module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "color-container"
  }, [_c('div', {
    class: {
      'color-display': true, 'select-active': _vm.selectedColor !== null
    }
  }, _vm._l((_vm.colors), function(color) {
    return _c('div', {
      class: {
        'color-option hoverable': true, 'selected': _vm.selectedColor === color
      },
      on: {
        "click": function($event) {
          _vm.selectedColor === color ? _vm.selectColor(null) : _vm.selectColor(color)
        }
      }
    }, [_c('span', {
      staticClass: "color-name"
    }, [_vm._v(_vm._s(color.name))]), _vm._v(" "), _c('img', {
      attrs: {
        "src": color.img
      }
    })])
  }), 0), _vm._v(" "), (_vm.selectedColor !== null) ? _c('div', {
    staticClass: "color-description"
  }, [_c('h4', [_vm._v(_vm._s(_vm.selectedColor.full_name))]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.selectedColor.fabric.description)
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54cf713e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ColorDisplay.vue
// module id = 219
// module chunks = 1